import {
  Box,
  Inline,
  Rating,
  Stack,
  Text,
  Tiles,
  Loader,
} from 'braid-design-system';

import { formatRating } from '../../../utils/rating';

import type { CompanyReviewSummaryBreakdown } from '../../../models/CompanyProfile';

interface Props {
  model?: CompanyReviewSummaryBreakdown[];
}

export const ReviewSummaryBreakdown = ({ model }: Props) => {
  if (!model) {
    return <Loader />;
  }
  const reviewSummaryBreakdowns = model;

  return (
    <Stack space="large">
      <Tiles columns={[1, 3]} space={['xlarge', 'large']}>
        {reviewSummaryBreakdowns &&
          reviewSummaryBreakdowns.map((rating, index) => (
            <Box key={`rating-${index}`}>
              {rating && (
                <Stack space="small">
                  <Text align="center">{rating.description}</Text>
                  <Inline space="small" align="center">
                    <Text weight="strong">
                      {formatRating(rating.rating ?? 1, 1)}
                    </Text>
                    <Rating rating={rating.rating ?? 1} variant="starsOnly" />
                  </Inline>
                </Stack>
              )}
            </Box>
          ))}
      </Tiles>
    </Stack>
  );
};
